import React, { useState } from 'react';

const Description = ({ description }) => {
  const [ isOpen, setIsOpen ] = useState(false);

  return (
    <div>
      <p className={`text-black-999 text-fz-13px mb-3 ${isOpen ? '' : 'line-3'}`}>
        {description}
      </p>
      <p 
        id="read-more" 
        className="text-info text-fz-11px mt-1 mb-0 mr-3 cursor-pointer text-right"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? '閉じる' : 'もっと見る'}
      </p>
    </div>
  )
};

export default Description;